import { changeStyle, formatYearDate } from "../../utils/format";
import {
  ColumnLayout,
  Box,
  SpaceBetween,
  Container,
  Badge,
  Header,
  TextContent,
  Grid,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { getContractStyleLabel } from "./util";
import { MerchantInfoResponse } from "../../features/api-interfaces";

interface ICorpInfoForm {
  corpInfo: MerchantInfoResponse;
  hasCreatedBy: string;
  hasCreatedAt: string;
}

const CorpInfoForm = (props: ICorpInfoForm) => {
  const { corpInfo, hasCreatedBy, hasCreatedAt } = props;

  return (
    <Container
      header={
        <ColumnLayout columns={2}>
          <Header variant="h2">{LABELS.FORM_TITLE}</Header>
          {/* TODO: 最終更新者最終更新日 実装するか未定 */}
          {hasCreatedBy && (
            <Box float={"right"}>
              <Badge color={"green"}>
                {LABELS.LAST_UPDATER}
                {hasCreatedBy}/{LABELS.LAST_UPDATING_TIME}
                {formatYearDate(hasCreatedAt)}
              </Badge>
            </Box>
          )}
        </ColumnLayout>
      }
    >
            <SpaceBetween direction="vertical" size="xxs">
              <Grid gridDefinition={[{ colspan: 1 }, { colspan: 11 }]}>
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <h4>{LABELS.CONTRACT_STYLE}</h4>
              </TextContent>
              </SpaceBetween> 
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <p>
                {getContractStyleLabel(corpInfo.contractStyles)}
              </p>
              </TextContent>
              </SpaceBetween>
              </Grid>
              <Grid gridDefinition={[{ colspan: 1 }, { colspan: 4 },{ colspan: 1 }, { colspan: 6 }]}>
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <h4>{LABELS.CORP_NAME}</h4>
              </TextContent>
              </SpaceBetween> 
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <p>{corpInfo.companyName}</p>
              </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <h4>{LABELS.CORPORATE_NUMBER}</h4>
              </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <p>{corpInfo.corporateNumber ?? LABELS.BLANK_SPACE_ONE}</p>
              </TextContent>
              </SpaceBetween>
              </Grid>

              <Grid gridDefinition={[{ colspan: 1 }, { colspan: 4 },{ colspan: 1 }, { colspan: 6 }]}>
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <h4>{LABELS.CORP_KANA}</h4>
              </TextContent>
              </SpaceBetween> 
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <p>{corpInfo.companyNameKana}</p>
              </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <h4>{LABELS.CORP_ENG}</h4>
              </TextContent>
              </SpaceBetween>
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <p>
                {corpInfo.companyNameAlphabetical ?? LABELS.BLANK_SPACE_ONE}
              </p>
              </TextContent>
              </SpaceBetween>
              </Grid>

              <Grid gridDefinition={[{ colspan: 1 }, { colspan: 11 }]}>
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <h4>{LABELS.ADDRESS}</h4>
              </TextContent>
              </SpaceBetween> 
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <p>
                {(corpInfo.postalCode
                    ? changeStyle(corpInfo.postalCode ?? "")
                    : LABELS.BLANK_SPACE_ONE) +
                  LABELS.BLANK_SPACE_ONE +
                  (corpInfo.address1 ?? LABELS.BLANK_SPACE_ONE) +
                  (corpInfo.address2 ?? LABELS.BLANK_SPACE_ONE)}
              </p>
              </TextContent>
              </SpaceBetween>
              </Grid>
              <Grid gridDefinition={[{ colspan: 1 }, { colspan: 11 }]}>
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <h4>{LABELS.TEL}</h4>
              </TextContent>
              </SpaceBetween> 
              <SpaceBetween direction="vertical" size="xxs">
              <TextContent>
              <p>{corpInfo.phoneNumber}</p>
              </TextContent>
              </SpaceBetween>
              </Grid>
            </SpaceBetween> 
    </Container>
  );
};
export default CorpInfoForm;
